import styled, { keyframes } from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const { mlbWhite } = COLORS;

const ellipsesAnimation = keyframes`
    0% {
        content: '.';
    }
    25% {
        content: '..';
    }
    50% {
        content: '...';
    }
    75% {
        content: '';
    }
`;

export const ConnectionStatus = styled.div`
    position: relative;
    display: block;
    font-family: var(--gameday-primary-font);
    color: ${mlbWhite};
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    padding: 8px;
    background: var(--gameday-alert-red);
    width: 100%;
    text-align: center;
    transition: all 0.5s ease-in-out;
    transform: ${({ $errorStatus }) => $errorStatus ? 'translateY(0)' : 'translateY(-100%)'};
    height: ${({ $errorStatus }) => $errorStatus ? 'auto' : '0'};
    padding: ${({ $errorStatus }) => $errorStatus ? '8px 0' : '0'};
    ${({ $errorStatus }) => {
            if (!$errorStatus) {
                return `
                    span {
                        visibility: hidden;
                    }
                `;
            }
        }};
`;

export const EllipsesContainer = styled.span`
    ::after {
        display: inline-block;
        width: 1px;
        content : '';
        animation: ${ellipsesAnimation} 2.5s infinite steps(1);
    }
`;
